import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import Title from './dev/Title';
import Subtitle from './dev/Subtitle';
import Input from './dev/Input'
import EditIcon from '../icon/EditIcon'
import StyleLink from '../dev/StyleLink'

const Profile = ({
    messages, toggleEdit, editUserInfoInput, editUserInfoSubmit, editUserInfoCancel,
    state: {
        userInfo: { company, country, email, name, nickName, phone, plan, position, provider },
        isEdit, editedUserInfo
    }}) => {
        const profileItems = [
            {
                firstKey: `${messages.user_name}：`,
                firstValue: name,
                firstCondition: 'name',
                secondKey: `${messages.user_tell}：`,
                secondValue: phone,
                secondCondition: 'phone',
            },{
                firstKey: `${messages.user_nicknme}：`,
                firstValue: nickName,
                firstCondition: 'nickName',
                secondKey: `${messages.user_country}：`,
                secondValue: country,
                secondCondition: 'country',
            },{
                firstKey: `${messages.user_company}：`,
                firstValue: company,
                firstCondition: 'company',
                secondKey: '',
                secondValue: '',
                secondCondition: '',
            },{
                firstKey: `${messages.user_title}：`,
                firstValue: position,
                firstCondition: 'position',
                secondKey: '',
                secondValue: '',
                secondCondition: '',
            }
        ]
        const renderProfileItem = ({ firstKey, firstValue, firstCondition, secondKey, secondValue, secondCondition}) => {
            return (
                <Content>
                    <Subtitle>
                        <div>{firstKey}</div>
                        {isEdit
                            ? <Input
                                onChange={editUserInfoInput(firstCondition)} 
                                onKeyPress={e => e.key === "Enter" && editUserInfoSubmit()}
                                value={editedUserInfo[firstCondition]} 
                                defaultValue={firstValue}
                                type="text" placeholder={''}/>
                            : <div>{firstValue}</div>}
                    </Subtitle>
                    <Subtitle>
                        <div>{secondKey}</div>
                        {isEdit && secondKey !== ''
                            ?  <Input
                                onChange={editUserInfoInput(secondCondition)} 
                                onKeyPress={e => e.key === "Enter" && editUserInfoSubmit()}
                                value={editedUserInfo[secondCondition]}
                                defaultValue={secondValue}                                
                                type="text" placeholder={''}/>
                            : <div>{secondValue}</div>}
                    </Subtitle>
                </Content>
            )
        }
        return (
            <Container>
                <Wrap>
                    <Title bottom>{messages.user_info}</Title>
                    <Content profile>
                        <Subtitle profile>
                            <div>{`${messages.user_mail}：`}</div>
                            {window.innerWidth > 500 && <div>{email}</div>}
                            {provider !== 'google' && window.innerWidth > 500 &&
                                <StyleLink to={'/EditPassword'}><Edit>{messages.user_reset_password}</Edit></StyleLink>}
                        </Subtitle>
                        {window.innerWidth <= 500 && <Subtitle>{email}</Subtitle>}
                        {/* rwd 防止email過長 */}
                        <Subtitle>
                            <div>{`${messages.user_plan}：`}</div>
                            <div>{plan}</div>
                            { !(plan === 'Agency(Admin)'|| plan === 'Agency(Member)') && <StyleLink to={'/Pricing'}><Edit>{messages.user_upgrade}</Edit></StyleLink>}
                        </Subtitle>
                    </Content>
                </Wrap>
                <Wrap>
                    <EditIconWrap isActive={!isEdit} onClick={()=> toggleEdit(true)}>
                        <EditIcon width={15}/>
                    </EditIconWrap>
                    {profileItems.map(i => renderProfileItem(i))}
                    <Footer isActive={isEdit}>
                        <Edit onClick={editUserInfoSubmit}>{messages.edit}</Edit>
                        <Edit onClick={editUserInfoCancel}>{messages.cancel}</Edit>
                    </Footer>
                </Wrap>
            </Container>
        )
}

const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(Profile);
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 900px;
    margin-top: 30px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);  
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 20px 20px 0 20px;
    }        
`
const Wrap = styled.div`
    position: relative;
    padding: 48px;
    border-bottom: 1px solid #e6e6e6;
    &:last-child {
        border-bottom: 0;
    }
    @media (max-width: 900px){
        padding: 24px;
    } 
`
const Content = styled.div`
    display: flex;
    ${Subtitle} {
        ${({ profile }) => profile ? 'width: auto' : 'width: 50%;'}
        div:first-child {
            min-width: 88px;
        }
    }
    @media (max-width: 900px){
        flex-direction: column;
        ${Subtitle} {
            width: 100%;
        }
    }
`
const Edit = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 50px;
    padding: 0 5px;
    margin: 0 8px;
    color: #fff;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`
const EditIconWrap = styled.div`
    position: absolute;
    display: ${props => props.isActive ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    /* top: 24px;
    right: 24px;
    transform: translate(50%, -50%); */
    cursor: pointer;
`
const Footer = styled.div`
    display: ${props => props.isActive ? 'flex' : 'none'};
    justify-content: center;
    margin-top: 20px;
    padding: 0 30%;
`


// WEBPACK FOOTER //
// ./src/UserInfo/Profile.js